import { lazy, Suspense, useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import { AppLoadingFallback } from "@/app/AppLoadingFallback";
import { routerFuture } from "@/app/router-future";
import { trackTopMailPageView } from "@/app/top-mail-counter";

const PublicApp = lazy(() => import("@/landing/PublicApp"));
const AuthenticatedApp = lazy(() => import("@/app/AuthenticatedApp"));

function TopMailRouteViews() {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    if (pathname === "/app/internal" || pathname.startsWith("/app/internal/")) return;
    trackTopMailPageView(pathname);
  }, [pathname]);

  return null;
}

export default function WebApp() {
  return (
    <BrowserRouter future={routerFuture}>
      <TopMailRouteViews />
      <Suspense fallback={<AppLoadingFallback />}>
        <Routes>
          <Route path="/app/*" element={<AuthenticatedApp />} />
          <Route path="*" element={<PublicApp />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
